export const TRANSLATIONS = {
    EN: {
        ADMIN: {
            ALL: 'All',
            YES: 'Yes',
            NO: 'No',
            EDIT_MEMBERS_IDENTIFICATION: 'Edit information for identification',
            SELECT_MONTH: 'Select a month',
            CREATE_PAYOUT: 'Create payout',
            DELETE_BATCH: 'Delete batch',
            FINALIZE_BATCH: 'Finalize batch',
            SELECT_THE_DATE_RANGE: 'Select the date range',
            SELECT_BATCH: 'Select the batch',
            ADVISOR: 'Advisor',
            CLIENT: 'Client',
            REQUESTER: 'Requester',
            BOOKKEEPER: 'Bookkeeper',
            NOTARY: 'Notary',
            SERVICE_PROVIDER: 'Service provider',
            CLIENT_TYPE: 'Client type',
            TOTAL_REVENUE: 'Total Revenue',
            TOTAL_TRANSACTIONS: 'Total Transactions',
            TOTAL_LEADS: 'Total Leads',
            EDIT_SHAREHOLDERS: 'Edit shareholders',
            COMPANY_NAME: 'Company name',
            DIRECTOR: 'Director',
            SHAREHOLDER_ADDED: 'Shareholder added',
            SHAREHOLDER_REMOVED: 'Shareholder removed',
            NEXT_DISTRIBUTE_SHARES: 'Next: Distribute the shares',
            ACTIONS: 'Actions',
            CANT_DELETE_ALL_SHAREHOLDERS: "Can't delete all shareholders",
            PAYMENT_SKIPPED: 'Payment skipped',
            PAYMENT_SKIPPED_BY: 'by {name} at {date}',
            SELECT_MEMBERS: 'Select members',
            PRICE_INCL_VAT: 'Price incl VAT',
            PRICE_EX_VAT: 'Price ex VAT',
            SALE_PRICE_EX_VAT: 'Sale price ex VAT',
            EX_VAT: 'ex VAT',
            MARGIN: 'Margin',
            RETAINER: 'Retainer',
            COMPANY_REGISTRATION_NUMBER: 'Registration number',
            COMPANY_COUNTRY_RESIDENCY: 'Company country of residency',
            STATE: {
                NEW: 'New',
                PENDING: 'Pending',
                PAUSED: 'Paused',
                FAILED: 'Failed',
                CANCELLED: 'Cancelled',
                SUCCESSFUL: 'Successful',
                PROGRESS: 'In progress',
            },
            PURCHASE_STATE: {
                NEW: 'Created',
                APPROVED: 'Approved',
                SUCCESSFUL: 'Paid',
            },
            URGENCY: {
                REGULAR: 'Regular',
                MEDIUM: 'Medium',
                FAST: 'Fast',
                URGENT: 'Urgent',
            },
            PAID: 'Paid',
            DUE_DATE: 'Due date',
            HAS_DURATION: 'Has duration',
            INCORPORATION: 'Incorporation',
            LIQUIDATION: 'Liquidation',
            UBO: 'UBO',
            GENERAL_WORKFLOW: 'General workflow',
            BOOKKEEPING_OFFER: 'Bookkeeping offer',
            DGA_SALARY: 'DGA salary administration',
            PRODUCT: 'Product purchase',
            OTHER: 'Other',
            CLID: 'ClickID',
            MULTIPLE_TRANSACTIONS: 'Multiple transactions',
            CATEGORY: 'Category',
            JOB: 'Job',
            JOBS: {
                SHARE_TRANSFER: 'Share transfer',
                SHARE_MERGER: 'Share merger',
                AMENDMENT_OF_ARTICLES: 'Articles of association',
            },
            IS_ASSIGNED: 'Is assigned',
            ASSIGNED_TO: 'Assigned to',
            ENGLISH: 'English',
        },
    },
    NL: {
        ADMIN: {
            ALL: 'Alles',
            YES: 'Ja',
            NO: 'Nee',
            EDIT_MEMBERS_IDENTIFICATION: 'Bewerk gegevens voor identificatie',
            SELECT_MONTH: 'Selecteer een maand',
            CREATE_PAYOUT: 'Uitbetaling maken',
            DELETE_BATCH: 'Batch verwijderen',
            FINALIZE_BATCH: 'Batch voltooien',
            SELECT_THE_DATE_RANGE: 'Selecteer het datumbereik',
            SELECT_BATCH: 'Selecteer de batch',
            ADVISOR: 'Adviseur',
            CLIENT: 'Cliënt',
            REQUESTER: 'Aanvrager',
            BOOKKEEPER: 'Boekhouder',
            NOTARY: 'Notaris',
            SERVICE_PROVIDER: 'Dienstverlener',
            CLIENT_TYPE: 'Type cliënt',
            TOTAL_REVENUE: 'Totale omzet',
            TOTAL_TRANSACTIONS: 'Totaal transacties',
            TOTAL_LEADS: 'Totaal leads',
            EDIT_SHAREHOLDERS: 'Aandeelhouders bewerken',
            COMPANY_NAME: 'Bedrijfsnaam',
            DIRECTOR: 'Bestuurder',
            SHAREHOLDER_ADDED: 'Aandeelhouder toegevoegd',
            SHAREHOLDER_REMOVED: 'Aandeelhouder verwijderd',
            NEXT_DISTRIBUTE_SHARES: 'Volgende: Verdeel de aandelen',
            ACTIONS: 'Acties',
            CANT_DELETE_ALL_SHAREHOLDERS: 'Kan niet alle aandeelhouders verwijderen',
            PAYMENT_SKIPPED: 'Betaling overgeslagen',
            PAYMENT_SKIPPED_BY: 'door {name} om {date}',
            SELECT_MEMBERS: 'Selecteer leden',
            PRICE_INCL_VAT: 'Prijs incl BTW',
            PRICE_EX_VAT: 'Prijs ex BTW',
            SALE_PRICE_EX_VAT: 'Verkoopprijs ex BTW',
            EX_VAT: 'ex BTW',
            MARGIN: 'Marge',
            RETAINER: 'Retainer',
            COMPANY_REGISTRATION_NUMBER: 'KvK nummer',
            COMPANY_COUNTRY_RESIDENCY: 'Vestigingsland van het bedrijf',
            STATE: {
                NEW: 'Nieuw',
                PENDING: 'Lopend',
                PAUSED: 'Gepauzeerd',
                FAILED: 'Gefaald',
                CANCELLED: 'Geannuleerd',
                SUCCESSFUL: 'Succesvol',
                PROGRESS: 'Lopend',
            },
            PURCHASE_STATE: {
                NEW: 'Aangemaakt',
                APPROVED: 'Goedgekeurd',
                SUCCESSFUL: 'Uitbetaald',
            },
            URGENCY: {
                REGULAR: 'Normaal',
                FAST: 'Snel',
                URGENT: 'Spoed',
            },
            PAID: 'Betaald',
            DUE_DATE: 'Opleverdatum',
            HAS_DURATION: 'Heeft duur',
            INCORPORATION: 'Oprichting',
            LIQUIDATION: 'Opheffing',
            UBO: 'UBO',
            GENERAL_WORKFLOW: 'Generieke job',
            BOOKKEEPING_OFFER: 'Boekhoud offerte',
            DGA_SALARY: 'DGA salarisadministratie',
            PRODUCT: 'Product aankoop',
            OTHER: 'Overige',
            CLID: 'ClickID',
            MULTIPLE_TRANSACTIONS: 'Meerdere transacties',
            CATEGORY: 'Categorie',
            JOB: 'Job',
            JOBS: {
                SHARE_TRANSFER: 'Aandelenoverdracht',
                SHARE_MERGER: 'Aandelenfusie',
                AMENDMENT_OF_ARTICLES: 'Statutenwijziging',
            },
            IS_ASSIGNED: 'Is toegewezen',
            ASSIGNED_TO: 'Toegewezen aan',
            ENGLISH: 'Engels',
        },
    },
};
